import styled from 'styled-components';

/**
 * The backend's one-line title. Capped at one line so the list stays a list:
 * the whole story is in the detail.
 */
export const RowTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.darkGray};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
